import React, { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../lib/firebase';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import './transactionList.css';

const TransactionList = ({ userId }) => {
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [userName, setUserName] = useState('');
    const [balance, setBalance] = useState(0);

    const navigate = useNavigate(); // Initialize useNavigate

    useEffect(() => {
        const fetchTransactions = async () => {
            try {
                const userDoc = await getDoc(doc(db, 'users', userId));
                if (userDoc.exists()) {
                    const userData = userDoc.data();
                    if (userData && Array.isArray(userData.transactions)) {
                        let fetchedTransactions = userData.transactions || [];

                        // Validate and parse dates
                        fetchedTransactions = fetchedTransactions.map(transaction => {
                            const parsedDate = new Date(transaction.date);
                            return {
                                ...transaction,
                                date: parsedDate instanceof Date && !isNaN(parsedDate) ? parsedDate : new Date() // Default to current date if invalid
                            };
                        });

                        // Sort transactions by date (latest to earliest)
                        fetchedTransactions = fetchedTransactions.sort((a, b) => b.date - a.date);
                        setTransactions(fetchedTransactions);

                        setUserName(userData.fullName || ''); // Ensure fullName is defined

                        // Calculate balance
                        const calculatedBalance = fetchedTransactions.reduce((total, transaction) => (
                            transaction.type === 'credit' ? total + transaction.amount : total - transaction.amount
                        ), 0);
                        setBalance(calculatedBalance);
                    } else {
                        setError('No transactions found or transactions data is invalid.');
                    }
                } else {
                    setError('User not found.');
                }
                setLoading(false);
            } catch (error) {
                console.error('Error fetching transactions: ', error);
                setError(`Error fetching transactions: ${error.message}`);
                setLoading(false);
            }
        };

        fetchTransactions();
    }, [userId]);

    const handleViewAllTransactions = () => {
        navigate(`/user/${userId}/transactions`); // Correctly navigate to the all-transactions page
    };

    if (loading) {
        return <div>Loading Account Logs ...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    if (transactions.length === 0) {
        return <div className='pageCover'>No transactions found.</div>;
    }

    // Slice the transactions array to get only the first 5 transactions
    const first5Transactions = transactions.slice(0, 5);

    return (
        <div className="transaction-list">
            <h2>Recent Transactions</h2>

            <div className='userHeadings'>
                <h6>{userName}'s Balance:
                    <> ${balance.toFixed(2)}</>
                </h6>
            </div>

            <table>
                <thead>
                    <tr className='thead'>
                        <th>Amount</th>
                        <th>Description</th>
                        <th>Date</th>
                    </tr>
                </thead>
                <tbody>
                    {first5Transactions.map((transaction, index) => (
                        <tr onClick={handleViewAllTransactions} key={index} className={transaction.type === 'debit' ? 'debit' : 'credit'}>
                            <td>${transaction.amount.toFixed(2)}</td>
                            <td>{transaction.description || 'N/A'}</td>
                            <td>{format(transaction.date, 'MMMM d, yyyy')}</td> {/* Updated date formatting */}
                        </tr>
                    ))}
                </tbody>
            </table>

            <div className='centerBox'>
                <button onClick={handleViewAllTransactions} className="logBtn">
                    View All Transactions
                </button>
            </div>
        </div>
    );
};

export default TransactionList;
